export default __webpack_public_path__ + "static/media/Q8-1.79fc2227.jpg";